import React from 'react'
import { useMount } from 'react-use'
import { Redirect, useRouteMatch } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { GA_EVENT, gtm } from 'lib/gtm'
import cookies from 'lib/cookies'
import { stringToLocationObject } from 'lib/location'
import { LOGIN_STATUS } from 'lib/constants'
import { logException } from 'lib/errors'
import { clearLoginState, getOrCreateLoginState } from './Auth'
import { debugLog } from 'lib/console'
import { getLocale } from 'lib/utils/getLocale'

import AuthLogic from './AuthLogic'

const AuthSsoLoginCallbackHandler = () => {
    const match = useRouteMatch()
    const { status } = match.params

    const loginState = getOrCreateLoginState()
    clearLoginState()

    const { i18n } = useTranslation()

    let target = `${getLocale(i18n.language) || '/'}`

    useMount(() => debugLog('auth - AuthSsoLoginCallbackHandler - status:', status, ' loginState:', loginState))

    switch (status) {
    case LOGIN_STATUS.SUCCESS:
        target = loginState.successTarget

        cookies.set('userLoggedIn', 1)
        cookies.remove('sessionExpired')

        gtm.pushGaEvent(GA_EVENT.LOGIN, { login: 'success', type: 'alma-tunnus' })
        gtm.pushGaEvent(GA_EVENT.LOGIN_SUCCESS, { eventAction: 'alma-tunnus' })
        break
    case LOGIN_STATUS.FAILED:
        target = loginState.failedTarget

        cookies.remove('userLoggedIn')

        gtm.pushGaEvent(GA_EVENT.LOGIN, { login: status, type: 'alma-tunnus' })
        gtm.pushGaEvent(GA_EVENT.LOGIN_FAILED, { eventAction: 'alma-tunnus' })
        break
    default:
        logException(`Invalid login status: ${status}`)
    }

    const targetLocation = stringToLocationObject(target)

    return status === LOGIN_STATUS.SUCCESS ? (
        <Redirect to={{ ...targetLocation }} />
    ) : (
        <AuthLogic onMount={({ logout }) => logout(target)} />
    )
}

export default AuthSsoLoginCallbackHandler
